export default __webpack_public_path__ + "static/media/computer.1f1506aa.svg";